<div *ngIf="state" class="state-airports">
  <div class="state-airports__wrapper">
    <h1 class="state-airports__header">Airports in {{ state.name }}</h1>
    <div class="state-airports__subheader">
      <a [routerLink]="['/airports/state']">&laquo; Back to States</a>
    </div>
    <div class="state-airports__body">
      <app-state-view [promise]="airportsPromise">
        <loading-state>
          <mat-spinner [diameter]="24" class="state-airports__spinner"></mat-spinner>
        </loading-state>
        <error-state>
          <div class="state-airports__placeholder state-airports__placeholder--error">
            <mat-icon class="state-airports__placeholder-icon">warning</mat-icon>
            <div class="state-airports__placeholder-message">
              An error occurred loading airports. Please try again later.
            </div>
          </div>
        </error-state>
        <content-state>
          <div *ngIf="sortedAirports.length; else placeholder" class="state-airports__listing">
            <div *ngFor="let airport of sortedAirports" class="state-airports__airport">
              <a [routerLink]="(airport.sourceId === 10 || airport.sourceId === 12) ?
                ['/airports', airport.identifier, 'island'] : ['/airports', airport.identifier]" class="state-airports__airport-link">
                {{ airport.identifier }} - {{ airport.name }}
              </a>
              <app-airport-icons class="state-airports__icons" [airport]="airport" [compact]="true"></app-airport-icons>
            </div>
          </div>
        </content-state>
      </app-state-view>
    </div>
  </div>
</div>
<ng-template #placeholder>
  <div class="state-airports__placeholder">
    <mat-icon class="state-airports__placeholder-icon">info</mat-icon>
    <div class="state-airports__placeholder-message">No airports found in {{ state.name }}.</div>
  </div>
</ng-template>
